export function writeGridFields(element, values) {
  for (const [name, value] of Object.entries(values)) {
    // Rails checkbox helpers also emit a hidden false value. Leave that intact.
    const visible = name === 'grid_detection_approximate' ? '' : ':not([type="hidden"])';
    const input = element.querySelector(`[name="game_map[${name}]"]${visible}`);
    if (!input) continue;
    if (input.type === 'checkbox') input.checked = [true, 'true', '1', 1].includes(value);
    else input.value = value;
  }
}

export function readGridFields(form) {
  const values = {};
  for (const [name, value] of new FormData(form)) {
    const match = name.match(/^game_map\[(grid_\w+)\]$/);
    if (match) values[match[1]] = value;
  }
  return values;
}
